import {useState} from 'react';

import {AdvancedSearchType} from 'src/openapi/admin/models/AdvancedSearchType';
import {SavedListType} from 'src/openapi/admin/models/SavedListType';

import {FilterableType, SavedSearchType, TypeFilterValue} from '../../../typedef';


type UseTypeFilterProps = {
    savedSearchType: SavedSearchType,
    onTypeFilterChange?: (filter: AdvancedSearchType[]) => void,
    onListTypeFilterChange?: (filter: SavedListType[]) => void,
};

export const useTypeFilter = ({
    savedSearchType,
    onTypeFilterChange,
    onListTypeFilterChange,
}: UseTypeFilterProps) => {
    const [typeFilterValue, setTypeFilterValue] = useState<TypeFilterValue>({
        values: [],
        includeBlanks: false,
        inverted: false,
    });
    const [isTypeFilterActive, setIsTypeFilterActive] = useState(false);

    const [selectedTypeValue, setSelectedTypeValue] = useState<FilterableType
        | FilterableType[]
        | undefined>(undefined);

    const handleApplyTypeFilter = (filter: TypeFilterValue) => {
        setTypeFilterValue(filter);
        setIsTypeFilterActive(filter.values.length > 0 || filter.includeBlanks);


        if (savedSearchType === 'SEARCH') {
            // Convert filter values to AdvancedSearchType array for searches
            const typeFilters: AdvancedSearchType[] = filter.values
                .filter(value => Object.values(AdvancedSearchType).includes(value as AdvancedSearchType))
                .map(value => value as AdvancedSearchType);
            onTypeFilterChange?.(typeFilters);
        } else {
            // Convert filter values to SavedListType array for lists
            const listTypeFilters: SavedListType[] = filter.values
                .filter(value => Object.values(SavedListType).includes(value as SavedListType))
                .map(value => value as SavedListType);
            onListTypeFilterChange?.(listTypeFilters);
        }
    };

    const handleTypeSelection = (value: FilterableType | FilterableType[] | undefined) => {
        setSelectedTypeValue(value);
    };

    const handleResetTypeFilter = () => {
        setTypeFilterValue({values: [], includeBlanks: false, inverted: false});
        setIsTypeFilterActive(false);
        setSelectedTypeValue(undefined);


        if (savedSearchType === 'SEARCH') {
            onTypeFilterChange?.([]);
        } else {
            onListTypeFilterChange?.([]);
        }
    };

    const handleCancelTypeFilter = () => {
        if (isTypeFilterActive) {
            setSelectedTypeValue(typeFilterValue.values as FilterableType[]);
        } else {
            setSelectedTypeValue(undefined);
        }
    };

    return {
        typeFilterValue,
        isTypeFilterActive,
        selectedTypeValue,
        handleApplyTypeFilter,
        handleTypeSelection,
        handleResetTypeFilter,
        handleCancelTypeFilter,
    };
};
